import crypto from "crypto-js"
import mapMessage from "../state/mapMessage";

// one connection per session; disconnectws() stops it and the reconnect loop
let currentWs: WebSocket | null = null
let reconnectTimer: ReturnType<typeof setTimeout> | undefined
let stopped = true
// the latest handlers; replaced on every connectws call so events always reach the
// current store (e.g. after a hot reload in development or a re-login)
let handlers = { setlastUpate: (() => {}) as any, updateRoom: (() => {}) as any, updateDevice: (() => {}) as any, updateLight: (() => {}) as any }

export function connectws(address: string, setlastUpate: any, updateRoom: any, updateDevice: any, updateLight: any) {
    handlers = { setlastUpate, updateRoom, updateDevice, updateLight }
    if (!stopped) {
        // already connected or reconnecting
        return
    }
    stopped = false
    open(address)
}

export function disconnectws() {
    stopped = true
    clearTimeout(reconnectTimer)
    reconnectTimer = undefined
    if (currentWs) {
        currentWs.close()
        currentWs = null
    }
}

function open(address: string) {
    var ws = new WebSocket(address);
    currentWs = ws

    //console.log('websocket connected 1')
    ws.onmessage = e => {
        const { setlastUpate, updateRoom, updateDevice, updateLight } = handlers
        // a message was received
        //console.log(e.data);

        var bytes = crypto.AES.decrypt(JSON.parse(e.data).payload, 'P8SSw0rd');
        var origmessage = bytes.toString(crypto.enc.Utf8);
        //console.log(origmessage)
        //Object.entries(JSON.parse(e.data)).forEach(([key, value]) => console.log(`${key}: ${value}`))
        const message = JSON.parse(origmessage)
        if (message.topic == 'HMevent') {
            const protocol = message.payload[1].protocol
            const { roomId, deviceId, action, value, dtype } = mapMessage(message, protocol)
            if (dtype == 'room') {
                updateRoom(roomId, action, value)
            }
            if (dtype == 'heating') {
                updateDevice(roomId,deviceId, action, value)
            }

            //console.log('measurement', message.measurement)
            //console.log('value', message.payload[0])
            //console.log('value', message.payload[1])
        }

        // { id, on } from nodered/lights-flow.json
        if (message.topic == 'LIGHTevent' && message.payload && typeof message.payload.on === 'boolean') {
            updateLight(message.payload.id, message.payload.on)
        }

        setlastUpate()

        if (message.topic == 'VBUSevent') {
            const protocol = message.payload[1].protocol
            const { roomId, deviceId, action, value } = mapMessage(message, protocol)
            if (value != "") {
                //updateRoom(roomid,action,value)
            }
            //console.log('measurement', message.measurement)
            //console.log('value', message.payload[0])
            //console.log('value', message.payload[1])
        }
    };

    ws.onclose = e => {
        console.log('connection closed')
        console.log(e.code, e.reason);
        if (currentWs === ws) {
            currentWs = null
        }
        if (!stopped) {
            reconnectTimer = setTimeout(function () { open(address) }, 5000);
        }
    };
}
